/** Time each toast stays visible in the notification center (ms). */
export const NOTIFICATION_DISPLAY_MS = 2500;

/** Max stacked notifications before oldest are dropped. */
export const NOTIFICATION_MAX_VISIBLE = 8;
